import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Twitter, Youtube, Mail } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="relative border-t border-[rgba(212,175,55,0.14)] bg-[#070709] pt-20 pb-10" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <h2 className="font-accent text-5xl sm:text-6xl text-champagne">MOVA</h2>
            <p className="mt-4 text-slate-400 max-w-sm leading-relaxed">
              Your complete lifestyle concierge. Plan, shop, travel and restore — curated, effortless, and entirely yours.
            </p>
            <div className="flex gap-4 mt-6">
              {[Instagram, Twitter, Youtube, Mail].map((Icon, i) => (
                <a key={i} href="#" className="w-10 h-10 rounded-full gold-border flex items-center justify-center text-amber-200 hover:bg-amber-400/10 transition-colors duration-200" data-testid={`footer-social-${i}`}>
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-8">
            <FooterCol title="Concierge" links={[["Plan", "/lifestyle"], ["Shop", "/fashion"], ["Travel", "/travel"]]} />
            <FooterCol title="Experience" links={[["Self-Care", "/self-care"], ["Live", "/lifestyle"], ["About", "/about"]]} />
            <FooterCol title="Account" links={[["My Dashboard", "/dashboard"], ["AI Planner", "/lifestyle"]]} />
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col sm:flex-row justify-between gap-4 text-xs text-slate-500">
          <span>© {new Date().getFullYear()} MOVA. Curated with intention.</span>
          <span className="tracking-[0.25em]">PLAN · SHOP · TRAVEL · SELF-CARE · LIVE</span>
        </div>
      </div>
    </footer>
  );
};

const FooterCol = ({ title, links }) => (
  <div>
    <h4 className="text-xs uppercase tracking-[0.25em] text-amber-400/90 font-semibold mb-5">{title}</h4>
    <ul className="space-y-3">
      {links.map(([label, to]) => (
        <li key={label}>
          <Link to={to} className="text-sm text-slate-400 hover:text-champagne transition-colors duration-200">{label}</Link>
        </li>
      ))}
    </ul>
  </div>
);
